import Product from '../model/Product';
import { ElementTypeEnum } from '../elementTypeMappings';

const findChildrenOfTypeFromProduct = (product: Product, types: ElementTypeEnum[]): Product[] => {

    const matches = product.children.filter( (child) => types.includes(child.productData.productType));
    return matches.concat(product.children.flatMap( (child) => findChildrenOfTypeFromProduct(child, types)));
};

const findChildrenOfTypeFromProducts = (products: Product[], types: ElementTypeEnum[]): Product[] => {
    return products.map(p => findChildrenOfTypeFromProduct(p, types)).flatMap(p => p);
};

const findFromProducts = (products: Product[], types: ElementTypeEnum[]) => {

    const rootLevelObjects = products.filter( (child) => types.includes(child.productData.productType));

    return rootLevelObjects.length > 0
        ? rootLevelObjects
        : findChildrenOfTypeFromProducts(products, types);
};

const findProductByGlobalId = (products: Product[], globalId: string): Product | undefined => {
    const product =  products.find(p => p.globalId === globalId);
    if (product) {
        return product;
    }
     
    products.forEach( (p) => {
        const found = findProductByGlobalId(p.children, globalId);
        if (found) {
            return found;
        }
    });

    return undefined;
}

export { findFromProducts, findProductByGlobalId };